import { Component, OnInit } from '@angular/core';
import { Route, Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { CoreService } from '../../helper/core/core.service';
import { Constant } from '../../helper/core/constant';
import { BuNameService } from '../../helper/core/bu-name.service';
import { UtilsService } from '../../helper/utils/utils.service';

@Component({
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.scss']
})
export class UnsubscribeComponent implements OnInit {

  public idSlot:string = "";
  public idUser:any;
  public event:any = false;
  public errorMsg: string = "";
  public errorApi:boolean = false;
  public timezone: string;

  unsubscribeForm: FormGroup;
  unsubscribeEmail: FormControl;

  constructor(
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private coreService: CoreService,
    private router: Router,
    private constant: Constant,
    private buNameService: BuNameService,
    private utils: UtilsService
  ) { }

  ngOnInit() {

    // Gestion du format de date
    registerLocaleData(localeFr, 'fr');

    // Validator du champ email
    this.unsubscribeEmail = new FormControl('',[
      Validators.required,
      Validators.pattern(this.constant.emailPattern)
    ]);

    // On récupère l'id du Slot / idUser depuis l'url
    this.route
      .queryParamMap
      .subscribe((params: ParamMap) => {
        this.idUser= params.get('user');
        this.idSlot = this.route.snapshot.paramMap.get('idSlot');
        this.getSlotInformation(this.idSlot);
      });

    // Construction de la composition du formulaire
    this.unsubscribeForm = this.builder.group({
      email: this.unsubscribeEmail,
    });

  }

  onSubmit(){
    if(this.unsubscribeForm.valid){
      // On request pour se désinscrire
      const obj = {
        idRegistration: this.idUser,
        email: this.unsubscribeForm.value.email,
      }
      this.errorMsg = "";

      // Api de désinscription
      this.coreService.unsubscribeToEvent(this.idSlot, obj).subscribe(
        () => {
          // Redirection vers les évènements
          this.router.navigate(['./'+this.event.buSlug+'/'+this.event.slug], {queryParams: { 'region': this.event.id_region, 'ville': this.event.id_city } });
        }, (dataError) => {
          // Message d'erreur de désinscription
          this.errorMsg = dataError;
          this.utils.scrollTo(".header__container");
        });
    }
  }

  /**
    * API Récupère les informations
    * de l'évènement par l'id du Slot
    * @param idSlot | String : id du Slot
    */
   private getSlotInformation(idSlot){
    this.coreService.getSlot(idSlot).subscribe(
    (data) => {
      // Si pas de paramètre user
      // On affiche page erreur
      if(!this.idUser)
          this.errorApi = true;

      // Attribution du nom de la BU dans le header
      this.buNameService.name = data.buName;
      // Attribution de l'url de la BU dans le header
      this.buNameService.url = data.buSlug;
      // Attribution de l'img de la BU dans le header
      this.buNameService.img = (typeof data.buLogo != "undefined") ? data.buLogo : "default" ;
      // Changement de title du site
      this.buNameService.title = "Désinscription - " + data.name;

      // Attribution des éléments de event
      this.event = data;

      this.timezone = data.currentGmt;

    }, (dataError) => {
      this.errorApi = true;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/screens/unsubscribe/unsubscribe.component.ts